import { ArrowRight } from "lucide-react";
import React from "react";
import { Updater } from "use-immer";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import {
  STRIPE_LATEST_PRODUCT_VERSION,
  StripeInterval,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { useGetOrganizationSummary } from "@src/api/organization-summaries/get-organization-summary";
import { BillingIntervalToggleGroup } from "@src/components/BillingPanel/components/BillingHeader/BillingIntervalToggleGroup";
import { theme } from "@src/theme";
import { pricingPage } from "@src/utils/linkSheet";
import { appUtmParams, openNewTab } from "@src/utils/openNewTab";

interface BillingHeaderProps {
  billingInterval: StripeInterval;
  setBillingInterval: Updater<StripeInterval>;
}

export const BillingHeader = ({
  billingInterval,
  setBillingInterval,
}: BillingHeaderProps) => {
  const adminOrg = useGetOrganizationSummary();

  const version =
    adminOrg.data.org.stripeSubscriptionSummaries
      .flatMap((os) => os.version)
      .sort()
      .pop()! || STRIPE_LATEST_PRODUCT_VERSION;

  return (
    <Grid container item justifyContent={"space-between"} alignItems={"center"}>
      <Grid item>
        <Grid container item columnSpacing={2} alignItems={"center"}>
          <Grid item>
            <IgTypography variant={"h2"} sx={{ fontWeight: 600 }}>
              Billing
            </IgTypography>
          </Grid>
          <Grid item>
            <BillingIntervalToggleGroup
              billingInterval={billingInterval}
              setBillingInterval={setBillingInterval}
            />
          </Grid>
          {version === STRIPE_LATEST_PRODUCT_VERSION ? null : (
            <Grid item>
              <IgTypography sx={{ color: theme.palette.text.secondary }}>
                You're on a legacy plan with no changes to your existing
                pricing.
              </IgTypography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item>
        <Grid container item columnSpacing={2}>
          <Grid item>
            <IgButton
              variant={"text"}
              onClick={() => {
                window.open(
                  `https://meetings.hubspot.com/igsam/igdemo${appUtmParams}`,
                  "_blank"
                );
              }}
            >
              Book a Demo
            </IgButton>
          </Grid>
          <Grid item>
            <IgButton
              variant={"outlined"}
              endIcon={<ArrowRight size={18} />}
              onClick={() => openNewTab(pricingPage, "Website Pricing Page")}
            >
              See Detailed Plan Comparisons
            </IgButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
